import { queryClient, apiRequest } from "../lib/queryClient";

const usersKey = "users";

export function useUsers(options = {}) {
  const {
    filters = {},
    sort = { direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchUsers = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortBy", sort.field);
    queryParams.append("sortOrder", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      queryParams.append(key, value);
    }
    if (filters.status && filters.status !== "all") {
      queryParams.append("status", filters.status);
    }
    if (filters.subscription && filters.subscription !== "all") {
      queryParams.append("subscription", filters.subscription);
    }
    if (filters.search) {
      queryParams.append("search", filters.search);
    }
    const response = await apiRequest(`/admin/user?${queryParams.toString()}`, {
      method: "GET",
    });

    return response;
  };

  const createUser = async (userData) => {
    const response = await apiRequest("/admin/user", {
      method: "POST",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [usersKey] });
    return response;
  };

  const updateUser = async (userData) => {
    const response = await apiRequest(`/admin/user/`, {
      method: "PUT",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [usersKey] });
    return response;
  };

  const toggleUserStatus = async (id) => {
    const response = await apiRequest(`/admin/user/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [usersKey] });
    return response;
  };

  const deleteUser = async (userId) => {
    const response = await apiRequest(`/admin/user/delete-user`, {
      method: "POST",
      body: JSON.stringify({user_id : userId}),
    });
    queryClient.invalidateQueries({ queryKey: [usersKey] });
    return response;
  };

  const address = async ({ type = "country", query }) => {
    const response = await apiRequest(`/address/${type}?${query}`, {
      method: "GET",
    });
    return response;
  };

  return {
    fetchUsers,
    createUser,
    updateUser,
    deleteUser,
    address,
    toggleUserStatus
  };
}
